import React from 'react';
import {useTranslation} from "react-i18next"; 
const JoinAsPartner = () => {
    const {t} = useTranslation ();
    return (
        <div className='container px-4 my-10 mx-auto' data-aos="fade-up-right" data-aos-duration="1500" data-aos-delay="500">
            <div className='flex justify-between items-center gap-10 flex-wrap bg-orange-50 px-8 py-8 rounded-lg shadow-lg'>
                <div>
                    <h3 className='text-4xl font-bold'>{t('de_a_rx_courier_partner_today')}</h3>
                    <p className='text-xl font-semibold mt-3'>{t('trust_sign_up_and_be_a_partner')}</p>
                </div>
                <div>
                    <a href={`${process.env.REACT_APP_BASE_URL}/merchant/sign-up`} target="_blank"  className="btn btn-primary text-xl px-10 text-black" >{t('sign_up')}</a>
                    
                </div>
            </div>
        </div>
    );
};

export default JoinAsPartner;
 